export default {
  displayRequests(state) {
    return state.requests;
  },
};
